import CheckOutSteps from "./steps";

export class CheckoutStepsWithoutGuests extends CheckOutSteps{

}